import remove from 'lodash/remove';
import api from '@/api';

export default {
  namespaced: true,

  state: {
    userGroups: [],
  },

  actions: {
    async GetUserGroups({ commit }) {
      const { userGroups } = await api.userGroup.getUserGroups();
      commit('SET_USERGROUPS', userGroups);
      return userGroups;
    },
    async AddUserGroup({ commit }, form) {
      const { userGroup } = await api.userGroup.addUserGroup({ ...form });
      commit('ADD_USERGROUP', userGroup);
      return userGroup;
    },
    async UpdateUserGroup({ commit }, form) {
      const { userGroup } = await api.userGroup.putUserGroup({ ...form });
      commit('UPDATE_USERGROUP', userGroup);
      return userGroup;
    },
    async DeleteUserGroup({ commit }, userGroup) {
      await api.userGroup.deleteUserGroup({ userGroupId: userGroup.id });
      commit('DELETE_USERGROUP', userGroup);
    },
  },

  mutations: {
    SET_USERGROUPS(state, userGroups) {
      state.userGroups = userGroups;
    },
    ADD_USERGROUP(state, userGroup) {
      const { userGroups } = state;
      state.userGroups = [...userGroups, userGroup];
    },
    UPDATE_USERGROUP(state, userGroup) {
      const { userGroups } = state;
      const target = userGroups.find(item => item.id === userGroup.id);
      if (target) {
        Object.assign(target, userGroup);
        state.userGroups = [...userGroups];
      }
    },
    DELETE_USERGROUP(state, userGroup) {
      const { userGroups } = state;
      remove(userGroups, item => item.id === userGroup.id);
      state.userGroups = [...userGroups];
    },
  },
};
